import { MATCH_APPOINTMENT_REASON_SCHEMA } from '@opencare/shared-types/models/match/MatchAppointmentReason';
import { ZodUtils } from '@opencare/shared-types/ZodUtils';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectDataMatch } from 'connect/selectors';
import { useHookResult } from 'utils/customHooks/use-hook-result';

export const MatchHooks = {
  useAppointmentReason: () => {
    const match = useSelector(selectDataMatch);

    const rawReason = match?.other?.reasonRaw?.overall;
    const reason = useMemo(
      () => ZodUtils.parseOrNull({
        value: rawReason,
        schema: MATCH_APPOINTMENT_REASON_SCHEMA,
      }),
      [rawReason],
    );

    return useHookResult({ reason });
  },
};
